import type { InfiniteData, Query, QueryKey, QueryState } from '@tanstack/react-query';

import { queryClient } from '~/providers/QueryClientProvider/queryClient';

export const findDataInQueryCache = <T>(queryKey: QueryKey, predicate: (data: T) => boolean): { data: T; state: QueryState } | null => {
  const cache = queryClient.getQueryCache().findAll({ queryKey }) as Query<{ data: T[] } | InfiniteData<{ data: T[] }>>[];
  const query = cache.find((query) => query.state.status === 'success' && extractQueryData(query.state.data).some(predicate)) ?? null;
  const data = extractQueryData(query?.state.data).find(predicate) ?? null;

  if (query === null || data === null) return null;

  return { data, state: query.state };
};

const extractQueryData = <T extends { data: unknown[] }>(data: T | InfiniteData<T> | undefined): T['data'] =>
  data === undefined ? [] : 'pages' in data ? data.pages.flatMap(({ data }) => data) : data.data;
